import mapValues from 'lodash/mapValues'
import axios from 'axios'

import config, { ENV } from '@/config'

const instance = axios.create()

if (ENV === 'test') instance.defaults.adapter = 'http'

/**
 * Error Handler (Interceptor)
 */
const errorHandler = (error) => {
  const { response } = error
  const output = {
    message: 'Request error',
    type: 'REQUEST',

    // With response
    ...response && {
      ...response.data,
      attributes: response.data.attributes ? mapValues(response.data.attributes, attr => attr.message) : null,
    },
  }
  return Promise.reject(Object.assign(error, output))
}

instance.interceptors.response.use(response => response, error => errorHandler(error))

const gatekeeperRequest = (options) => {
  const defaults = {
    method: 'GET',
    baseURL: config.api.gatekeeper,
  }

  return instance({ ...defaults, ...options })
}

export default gatekeeperRequest
